<template lang="html">
    <div class="excelEr-area">
      <el-dialog :visible.sync="dialogVisible" width="45%" >
         <div class="dialog-area">
               <el-scrollbar style="height:100%;">
                     <el-table
                        :data="compData"
                        @row-click = "lineCtrls"
                        ref="exStrees"
                        style="width: 100%">
                        <el-table-column type="expand">
                          <template slot-scope="props">
                             <el-form label-position="left" inline class="demo-table-expand">
                                 <template v-for="term in thead2">
                                   <el-form-item :label="term.name" >
                                       <span :class="{ active : errorRed(props.row,term.dataName,term)}">{{ props.row | formateData(term.dataName) }}</span>
                                   </el-form-item>
                                 </template>
                              </el-form>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="导入错误信息列表"
                            prop="readCode">
                          </el-table-column>
                      </el-table>
                      <div slot="footer" class="dialog-footer">
                          <el-button type="primary" size="small" @click="dialogVisible = false">确 定</el-button>
                      </div>
                </el-scrollbar>
         </div>
      </el-dialog>
    </div>
</template>

<script>
import { deepCopy } from '@/utils/object';
export default {
    props:['errorList','tableHeader','forNine'],
    data(){
        return {
             dialogVisible:false,
             tempHead:[],
             thead2:[],
             erList:[],
        }
    },

    computed:{
         compData:function(){
             
              var temps = [];
              for(var i in this.errorList){
                  var tempj = {};
                  tempj = this.errorList[i];
                  tempj.readCode = '第 '+(parseInt(i)+1)+' 条错误数据（点击查看）';
                  temps.push(tempj);
              };
              if(this.errorList.length>0){
                this.dialogVisible = true;
              }
              
              return temps;
         }
    },
    // watch: {
    //     errorList(val) {
    //         console.log('watch',val);
    //         var temps = [];
    //           for(var i in val){
    //               var tempj = {};
    //               tempj = val[i];
    //               tempj.readCode = '第 '+(parseInt(i)+1)+' 条错误数据（点击查看）';
    //               temps.push(tempj);
    //           };
    //         //   this.dialogVisible = true;
    //           return temps;
    //     },

    // },
    filters:{
        formateData:function(val,val1){
            console.log(val,val1);
            var es =  val.message;
            var cnt = val.param;

            var esTemp = {};
            var cntTemp = JSON.parse(cnt);
            if(es){
                var arrs = es.split(',');
                for(var i in arrs){
                    if(arrs[i]){
                        esTemp[arrs[i].split(":")[0]] = arrs[i].split(":")[1];
                    }
                };
            }
            if(esTemp[val1]){
                 return esTemp[val1];
            }else {
                 return cntTemp[val1];
            }

        }
    },
    methods:{
        handErrors:function(){
            this.dialogVisible = true;
        },

        lineCtrls:function(row, event, column){
            this.$refs.exStrees.toggleRowExpansion(row);
            this.thead2 = [];
            var storage = deepCopy(this.tempHead);
            for(var termp in storage){
                this.thead2.push(storage[termp]);
            }
        },

        errorRed:function(val1,val2,val4){
          var es =  val1.message;
          var esTemp = {};

          if(es){
              var arrs = es.split(',');
              for(var i in arrs){
                  esTemp[arrs[i].split(":")[0]] = arrs[i].split(":")[1];
              };
          };
          return esTemp[val2];
        }

    },
    created:function(){
        
      this.tempHead = [];
      var storage = deepCopy(this.tableHeader);
      for(var termp in storage){
          this.tempHead.push(storage[termp]);
      }
      if(this.forNine){
           var temp = {
               dataName:'xdtime',
               name:'修订时间'
           };
           this.tempHead.push(temp);
      };
      this.thead2 = this.tableHeader;
      console.log(storage,this.thead2,this.tableHeader);

    }
}
</script>

<style lang="css">

.excelEr-area .el-dialog__body{
    padding: 0px;
}

.excelEr-area .cell{
    text-align: left !important;
    font-size: 15px;
}

.excelEr-area .el-dialog__headerbtn{
   top: 12px;
}

.excelEr-area .el-table__header-wrapper .cell{
   color: red;
}

.excelEr-area  label {
    /* width: 120px; */
    color: #99a9bf;
  }

.excelEr-area .el-form-item {
    margin-right: 0 !important;
    margin-bottom: 0;
    margin-top: 0px;
    width: 100%;
    font-size: 14px;
    border-bottom: 1px solid #EBEEF5;
  }

  .excelEr-area .el-form-item__label{
    font-size: 14px;
  }

  .excelEr-area .active{
    color: red;
  }

  .excelEr-area .dialog-area{
    height: 650px;
    overflow: hidden;
  }

  .excelEr-area .el-scrollbar__wrap{
     overflow-x: hidden;
  }

  .excelEr-area .cell{
     font-size: 14px;
  }

  .excelEr-area .el-table__row{
      cursor: pointer;
  }

  .excelEr-area .el-form{
      margin-top: 0px;
  }


</style>



// WEBPACK FOOTER //
// excelError.vue?ac0a6c7c